module.exports = {
  title: '共创家—共创家web端',
  baseUrl: 'https://terminal-front-test.jifenxitong.com/', // 测试项目地址
  baseApi: 'https://applet1.jifenxitong.com/applet', // 测试api请求地址
  $cdn: 'https://hyjy-oss.oss-cn-chengdu.aliyuncs.com/mp/assets/'
};
